module.exports = __webpack_public_path__ + "img/2.79b97e53.png";